import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

import StakeholderValidations from 'register-partners-js/validations/stakeholder';

export default class RegisterStakeholder extends Model.extend(StakeholderValidations) {
  @attr() phoneNumber;
  @attr('boolean', { allowNull: true }) taxPayerOutsideLegalCountry;
  @attr('boolean', { allowNull: true }) usTaxPayer;
  @attr() firstName;
  @attr() lastName;
  @attr('string') kycProvider;

  @attr('string', { allowNull: true }) otherTaxResidencyCountry;
  @attr('string', { allowNull: true }) otherTaxIdentificationNumber;

  @attr('boolean', { allowNull: true, defaultValue: null }) usPerson;
  @attr('string', { allowNull: true, defaultValue: null }) usTaxIdentificationNumber;
  @attr('boolean', { allowNull: true, defaultValue: null }) selfPepDeclaration;

  @belongsTo('register-organization', { async: true, inverse: 'stakeholders' }) organization;
  @hasMany('register-document', { async: false, inverse: 'stakeholder' }) documents;
}
